import { Link, Navigate, useLocation } from "react-router-dom";
import { SignInRequiredCard } from "./Common/AuthActionGate";
import { hasPremiumAccess } from "../utils/access";

const ProtectedRoute = ({
  user,
  userProfile,
  loading,
  requireAdmin = false,
  requirePremium = false,
  loginPath = "/",
  children,
}) => {
  const location = useLocation();

  if (loading) {
    return <div className="card">Loading...</div>;
  }

  if (!user) {
    return (
      <SignInRequiredCard message="Create a free account or sign in to view this member-only page." />
    );
  }

  const accountStatus = userProfile?.accountStatus || "active";
  const isAdmin = userProfile?.admin === true || userProfile?.isAdmin === true;
  const premiumAllowed = hasPremiumAccess(userProfile);

  if (accountStatus === "banned") {
    return (
      <div className="card blocked-account-card">
        <h2>Account restricted</h2>
        <p>This account has been restricted and cannot access MyFarmingPal.</p>
        <p>
          If you believe this was a mistake, please{" "}
          <Link to="/contact">contact support</Link>.
        </p>
      </div>
    );
  }

  if (accountStatus === "deactivated") {
    return <Navigate to="/reactivate" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="card blocked-account-card">
        <h2>Admin access only</h2>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }

  if (requirePremium && !premiumAllowed) {
    return <Navigate to="/subscribe" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
